(function () {
  'use strict';

  // v3 — auto-click WMPF SEARCH on the seeker page, with an on-page debug
  // bar so we can see what's happening without DevTools.

  var FLAG_KEY = 'gcdbp:autoSearchOnSeekerPage';
  var TAG = '[autosearch]';

  var urlParams = new URLSearchParams(window.location.search);
  var urlForce = urlParams.get('autosearch') === '1';
  var debugVisible = urlForce || urlParams.get('debug') === '1' || true; // on for now while bedding in

  function setStatus(msg, color) {
    if (!debugVisible) return;
    var el = document.getElementById('scf-autosearch-status');
    if (!el) {
      el = document.createElement('div');
      el.id = 'scf-autosearch-status';
      el.style.cssText =
        'position:fixed;left:0;right:0;bottom:0;padding:8px 12px;' +
        'background:#222;color:#fff;font-family:monospace;font-size:12px;' +
        'z-index:99999;text-align:center;border-top:2px solid ' + (color || '#888') + ';';
      document.body.appendChild(el);
    }
    el.style.borderTopColor = color || '#888';
    el.textContent = TAG + ' ' + msg;
  }

  function clearStatusSoon() {
    setTimeout(function () {
      var el = document.getElementById('scf-autosearch-status');
      if (el) el.remove();
    }, 4000);
  }

  function log() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(TAG);
    console.log.apply(console, args);
  }

  var flagSet = sessionStorage.getItem(FLAG_KEY) === '1';

  if (!flagSet && !urlForce) {
    setStatus('flag not set — script ran but won\'t click (this is normal on direct visits)', '#888');
    clearStatusSoon();
    return;
  }

  setStatus('flag detected, polling…', '#1a6fd8');
  log('start', { flagSet: flagSet, urlForce: urlForce });

  var attempts = 0;
  var maxAttempts = 80; // ~16 s

  function findSearchButton() {
    // Try light DOM selectors first (the seeker results page renders here).
    var lightSelectors = [
      'button[name="search"]',
      'input[name="search"]',
      'button.search',
      'button.search-button',
      'input[type="submit"][value="SEARCH" i]',
      'input[type="submit"][value="Search" i]'
    ];
    for (var i = 0; i < lightSelectors.length; i++) {
      var hit = document.querySelector(lightSelectors[i]);
      if (hit) return hit;
    }

    // Text-content fallback: any clickable element whose visible text is
    // exactly "SEARCH" (the WMPF picker uses simple <button>SEARCH</button>
    // markup on the results page).
    var candidates = document.querySelectorAll('button, [role="button"], input[type="submit"]');
    for (var j = 0; j < candidates.length; j++) {
      var c = candidates[j];
      var txt = ((c.textContent || c.value || '') + '').trim().toUpperCase();
      if (txt === 'SEARCH') return c;
    }

    // Fall back to shadow DOM (header context if ever needed here).
    var root = document.querySelector('seeker-dropdown-parts-finder-root');
    if (root && root.shadowRoot) {
      for (var k = 0; k < lightSelectors.length; k++) {
        var sh = root.shadowRoot.querySelector(lightSelectors[k]);
        if (sh) return sh;
      }
    }

    return null;
  }

  function dumpButtonsForDiagnosis() {
    var sample = [];
    var all = document.querySelectorAll('button, input[type="submit"]');
    for (var i = 0; i < Math.min(all.length, 10); i++) {
      var b = all[i];
      sample.push({
        tag: b.tagName,
        name: b.getAttribute('name'),
        type: b.getAttribute('type'),
        cls: b.className,
        text: ((b.textContent || b.value || '') + '').trim().substring(0, 30)
      });
    }
    log('button inventory', { totalCount: all.length, sample: sample });
  }

  var interval = setInterval(function () {
    attempts++;

    var btn = findSearchButton();
    if (!btn) {
      if (attempts % 5 === 0) setStatus('waiting for SEARCH button (' + attempts + ')', '#1a6fd8');
      if (attempts >= maxAttempts) {
        clearInterval(interval);
        dumpButtonsForDiagnosis();
        setStatus('FAILED — button never appeared (open console for inventory)', '#c00');
      }
      return;
    }
    if (!btn) {
      if (attempts % 5 === 0) setStatus('waiting for SEARCH button (' + attempts + ')', '#1a6fd8');
      if (attempts >= maxAttempts) { clearInterval(interval); setStatus('FAILED — button never rendered', '#c00'); }
      return;
    }

    if (btn.disabled) {
      if (attempts % 5 === 0) setStatus('button disabled (' + attempts + ')', '#e8a005');
      if (attempts >= maxAttempts) { clearInterval(interval); setStatus('FAILED — button stayed disabled', '#c00'); }
      return;
    }

    // Found enabled button — give WMPF one tick, then try a few click
    // strategies so we cover lit-html, native click, and synthetic events.
    clearInterval(interval);
    try { sessionStorage.removeItem(FLAG_KEY); } catch (e) {}
    setStatus('button found — clicking…', '#0a8a3a');

    setTimeout(function () {
      try { btn.click(); } catch (e) { log('btn.click() threw', e); }
      try {
        btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      } catch (e) { log('dispatchEvent threw', e); }
      // If button is inside a form, try submitting it too.
      var form = btn.closest('form');
      if (form) {
        try { form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); } catch (e) { log('form submit threw', e); }
      }
      setStatus('clicked ✓ (took ' + attempts + ' attempts)', '#0a8a3a');
      clearStatusSoon();
    }, 100);
  }, 200);
})();
